import script from "./index.vue?vue&type=script&setup=true&name=member_index&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=member_index&lang=js"

const __exports__ = script;

export default __exports__